export function methodGet(path) {
  return new Promise((resolve, reject) => {
    const controller = new AbortController();
    let myHeaders = new Headers();
    let myInit = {
      headers: myHeaders,
      signal: controller.signal,
      method: "GET",
    };
    myHeaders.append("accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("APIKEY", "QSDGZEA168vez861OBNOAFZ61zev");

    fetch(path, myInit)
      .then((res) => {
        if (!res.ok)
          return res.json().then((err) => {
            throw err;
          });
        else return res.json();
      })
      .then(
        (result) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
  });
}

export function methodPost(path, params) {
  return new Promise((resolve, reject) => {
    const controller = new AbortController();
    let myHeaders = new Headers();
    let myInit = {
      headers: myHeaders,
      signal: controller.signal,
      method: "POST",
      body: JSON.stringify(params),
    };
    myHeaders.append("accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("APIKEY", "QSDGZEA168vez861OBNOAFZ61zev");

    fetch(path, myInit)
      .then((res) => {
        if (!res.ok)
          return res.json().then((err) => {
            throw err;
          });
        else return res.json();
      })
      .then(
        (result) => {
          resolve(result);
        },
        (error) => {
          alert(error.error.message);
          reject(error);
        }
      );
  });
}

export function waitForSeconds(seconds) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve();
    }, seconds * 1000);
  });
}

// surligne le texte pendant une recherche
export function getHighlightedText(text, highlight) {
  if (text === null) return "";
  const parts = text.split(new RegExp(`(${highlight})`, "gi"));
  return highlight === null || highlight === undefined || highlight === "" ? (
    text
  ) : (
    <span data-tag="allowRowEvents">
      {parts.map((part, i) => (
        <span
          data-tag="allowRowEvents"
          key={i}
          style={
            part.toLowerCase() === highlight.toLowerCase()
              ? { fontWeight: "bold", backgroundColor: "#ffd8d4" }
              : {}
          }
        >
          {part}
        </span>
      ))}
    </span>
  );
}

export function getPathParams() {
  let params = window.location.href.split("?")[1];
  if (params) {
    let res = {};
    params.split("&").forEach((e) => (res[e.split("=")[0]] = e.split("=")[1]));
    return res;
  } else return null;
}
